import { Component, forwardRef, OnInit } from '@angular/core';
import {
  AbstractControl,
  ControlValueAccessor,
  FormBuilder,
  FormGroup,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  Validator,
  Validators,
} from '@angular/forms';

@Component({
  selector: 'app-input-time',
  templateUrl: './input-time.component.html',
  styleUrls: ['./input-time.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputTimeComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => InputTimeComponent),
      multi: true,
    },
  ],
})

export class InputTimeComponent implements OnInit, ControlValueAccessor, Validator {
  mask_time = [/[0-2]/, /[0-9]/, ':', /[0-5]/, /[0-9]/];
  REGEX: any = /^\s*([01]?\d|2[0-3]):[0-5]\d\s*$/i;
  form: FormGroup;
  disabled: boolean;
  errors = [];

  onChange = (_: any) => {};
  onTouched = () => {};
  onValidationChange = () => {};

  constructor(private fb: FormBuilder) {
    this.initForm();
  }

  ngOnInit() {
    this.form.valueChanges.subscribe((resp: any) => {
      this.onChange(resp.time);
      this.onValidationChange();
    });
  }

  initForm() {
    this.form = this.fb.group({
      time: [null, Validators.pattern(new RegExp(this.REGEX))],
    });
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  registerOnValidatorChange(fn: () => void) {
    this.onValidationChange = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    isDisabled ? this.form.disable() : this.form.enable();
  }

  validate(control: AbstractControl): any | null {
    this.errors = [];
    if (control.errors) { this.errors.push(control.errors); }
    if (this.form.invalid) {
      return { invalid: true };
    } else {
      return null;
    }
  }

  writeValue(obj: any): void {
    if (obj) {
      if (typeof obj === 'number') {
        this.form.setValue({
          time: this.convertHM(obj),
        });
      } else {
        this.form.setValue({
          time: obj.replace(/(\d{1,2}:\d{2}):\d{2}/, '$1'),
        });
      }
    } else {
      this.form.setValue({
        time: null,
      });
    }
  }

  convertHM(value: any) {
    const sec = parseInt(value, 10);
    let hours: any = Math.floor(sec / 3600);
    let minutes: any = Math.floor((sec - hours * 3600) / 60);
    if (hours < 10) {
      hours = '0' + hours;
    }
    if (minutes < 10) {
      minutes = '0' + minutes;
    }
    return hours + ':' + minutes;
  }

  get isRequired(): boolean {
    if (this.errors) {
      const error = this.errors.filter((er) => er.required || er.invalidRequired);
      return error.length > 0;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/utils/input-time/components/input-time/input-time.component.ts